export enum MediaPanel {
  OnlinePanel,
  PsylarisLibrary,
  UploadPanel,
}
